import React from 'react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';
import { updateFolderEffect } from 'app/store/SongList/effects';
import { addAlertAction } from 'app/store/Alerts/slice';
import { FolderItem, Song } from 'types/song';
import { AppDispatch } from 'app/store';

export interface RemoveFromFolderDialogProps {
  folder?: FolderItem;
  song?: Song;
  selectedRowsIds?: string[];
  open: boolean;
  dispatch: AppDispatch;
  onClose: () => void;
}
export const RemoveFromFolderDialog: React.FC<RemoveFromFolderDialogProps> = ({
  dispatch,
  folder,
  song,
  selectedRowsIds = [],
  onClose,
  open,
}) => {
  const handleRemoveSongFromFolder = async () => {
    if (!folder || !song) {
      return;
    }

    try {
      if (selectedRowsIds.length > 0) {
        await dispatch(
          updateFolderEffect({
            guid: folder.guid,
            removeSongs: selectedRowsIds,
          })
        ).unwrap();

        dispatch(
          addAlertAction({
            message: `You have removed the selected songs from folder ${folder?.title}`,
          })
        );
      } else if (song) {
        await dispatch(
          updateFolderEffect({ guid: folder.guid, removeSongs: [song.guid] })
        ).unwrap();

        dispatch(
          addAlertAction({
            message: `You have removed the song ${song.title} from folder ${folder?.title}`,
          })
        );
      }

      onClose();
    } catch (e) {
      // Handle error
    }
  };

  const songsLabel =
    selectedRowsIds.length > 0 ? 'selected songs' : song?.title;
  const message = (
    <>
      Are you sure you want to remove <b>{songsLabel}</b> from{' '}
      <b>{folder?.title}</b> folder?
    </>
  );

  return (
    <ChakraConfirmationDialog
      title="Remove song from folder"
      actionButtonText="Remove"
      handleAction={handleRemoveSongFromFolder}
      isOpen={open}
      onClose={onClose}
      message={message}
    />
  );
};
